import { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { hasBrowserSession, isIdleExpired, markSessionExpiredNotice, touchSessionActivity } from '../authSession';
import { clearAuthSession } from '../services/serviceconfig';
import { performLogout } from '../services/LoginServices';

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'];

export default function SessionTimeoutMonitor() {
  const [cookies] = useCookies(['myToken']);
  const cookiesRef = useRef(cookies);
  const loggingOutRef = useRef(false);

  useEffect(() => {
    cookiesRef.current = cookies;
  }, [cookies]);

  useEffect(() => {
    const onActivity = () => touchSessionActivity();
    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });

    const expireSession = () => {
      if (loggingOutRef.current) {
        return;
      }
      const currentCookies = cookiesRef.current;
      if (!currentCookies?.myToken || !hasBrowserSession()) {
        return;
      }
      if (!isIdleExpired()) {
        return;
      }

      loggingOutRef.current = true;
      markSessionExpiredNotice();
      performLogout(currentCookies).catch(() => {});
      clearAuthSession();
      // Hard redirect avoids half-cleared cookie state crashing protected routes.
      window.location.assign('/');
    };

    const intervalId = window.setInterval(expireSession, 60 * 1000);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
      window.clearInterval(intervalId);
    };
  }, []);

  return null;
}
